import axios from 'axios'
import { AbstractService } from "@/services/nextshop/abstract.service";
import { AuthService } from '@/services/auth.service';
import $store from "@/state/store"

export class ReportService extends AbstractService {
  static get entity_report() {
    return `${process.env.VUE_APP_GATEWAY_API_URL}/proxy-gateway/gw-core`
  }

  static async getListProduct(params) {
    try {
      const response = await axios.post(
        `${this.entity_report}/item-compound/search`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async getReportCustomer(params) {
    try {
      const response = await axios.post(
        `${this.entity_report}/data-warehouse/roct/customer-report`,
        params, {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-app-id": process.env.VUE_APP_ID,
            "np-user-id": params.merchantId,
            "np-location-id": $store.state.auth.currentLocation

          }
        }
      )
      return response.data;
    } catch(error) {
      console.log(error)
    }
  }

  static async getReportOrder(params) {
    try {
      const response = await axios.post(
        `${this.entity_report}/data-warehouse/rot/order-report`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-app-id": process.env.VUE_APP_ID,
            "np-user-id": params.merchantId,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return response.data
    } catch(error) {
      console.log(error);
    }
  }

  static async getDataTime(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/order-report`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  // getDataProduct
  static async getDataProduct(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/item-report`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // Get all item
  static async getAllDataProduct(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/group-all-item-report`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }


  // getDataCustomer
  static async getDataCustomer(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/roct/customer-report`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // Get all data customer report
  static async getAllDataCustomer(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/roct/group-all-customer-report`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  
  static async getDataOrderRealTime(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/order-report-realtime`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getDataCustomerRealTime(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/roct/customer-report-realtime`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getDataAllCustomerRealTime(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/roct/group-all-customer-report-realtime`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getDataProductRealTime(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/item-report-realtime`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getDataAllProductRealTime(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/group-all-item-report-realtime`,params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // NEW DASHBOARD DATA ALL ITEM REPORT
  static async getDataAllItemReport(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/item-report-v2`, params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // V2
  static async orderReportProfit(params) {
    try {
      const response = await this.callApi().post(`${this.entity_report}/data-warehouse/rot/order-report-v2`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async orderReportRealtimeProfit(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/order-report-realtime-v2`,
        params
      )
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async iTemReportProfit(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/item-report-v2`,
        params
      )
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async iTemReportRealtimeProfit(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_report}/data-warehouse/rot/item-report-realtime-v2`,
        params
      )
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async customerReportRealtimeRevenue(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_report}/data-warehouse/roct/customer-report-realtime-v2`,
        params
      )
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async customerReportRevenue(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_report}/data-warehouse/roct/customer-report-v2`,
        params
      )
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async paymentReportRevenue(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_report}/data-warehouse/rpot/payment-report`,
        params
      )
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  //V3
  static async orderReportV3(params) {
    try {
      const response = await this.callApi().post(`${this.entity_report}/data-warehouse/rot/order-report-V3`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async itemReportV3(params) {
    try {
      const response = await this.callApi().post(`${this.entity_report}/data-warehouse/rot/item-report-V3`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async customerReportV3(params) {
    try {
      const response = await this.callApi().post(`${this.entity_report}/data-warehouse/rot/customer-report-V3`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async totalItemReportV3(params) {
    try {
      const response = await this.callApi().post(`${this.entity_report}/data-warehouse/rot/total-item-report-V3`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async totalOrderReportV3(params) {
    try {
      const response = await this.callApi().post(`${this.entity_report}/data-warehouse/rot/total-order-report-V3`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async totalCustomerReportV3(params) {
    try {
      const response = await this.callApi().post(`${this.entity_report}/data-warehouse/rot/total-customer-report-V3`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async paymentReportV3(params) {
    try {
      const response = await this.callApi().post(`${this.entity_report}/data-warehouse/rpot/payment-report-V2`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async debitReportV3(params) {
    try {
      const response = await this.callApi().post(`/nsh/partner/api/report/part-ner-info`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async mcReportV3(mcID) {
    try {
      const response = await this.callApi().get(`${this.entity_report}/debt-note/statistic/${mcID}`)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async exportData(params) {
    try {
      const response = await this.callApi().post(
        `nsh/iex/api/item/download-data/item-report`,
        params
      );
      return response.data;
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  static async totalParnterReportV3(params) {
    try {
      const response = await this.callApi().post(`/nsh/partner/api/report/total-by-partner-type`, params)
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
}